import type { SpecialPricingLogReportItem, SpecialPricingSummaryReportItem } from "../../../../graphql/types"

export const CLEAR_SPECIAL_PRICING_REPORT_DATA = "specialPricingReport/clear"

export const clearSpecialPricingReportData = () => ({
    type: CLEAR_SPECIAL_PRICING_REPORT_DATA,
})

export const SPECIAL_PRICING_REPORT_AGENDA_MOUNTED = "specialPricingReport/mounted"

export const specialPricingReportAgendaMounted = () => ({
    type: SPECIAL_PRICING_REPORT_AGENDA_MOUNTED,
})
// LOG

export const FETCH_SPECIAL_PRICINGS_LOG_REPORT_REQUESTED = "specialPricingReport/log/requested"

export const fetchSpecialPricingsLogReportRequested = () => ({
    type: FETCH_SPECIAL_PRICINGS_LOG_REPORT_REQUESTED,
})

export const FETCH_SPECIAL_PRICINGS_LOG_REPORT_SUCCESS = "specialPricingReport/log/success"

export const fetchSpecialPricingsLogReportSuccess = (data: SpecialPricingLogReportItem[]) => ({
    type: FETCH_SPECIAL_PRICINGS_LOG_REPORT_SUCCESS,
    payload: {
        data: data,
    },
})

export const FETCH_SPECIAL_PRICINGS_LOG_REPORT_FAILURE = "specialPricingReport/log/failure"

export const fetchSpecialPricingsLogReportFailure = (error?: any) => ({
    type: FETCH_SPECIAL_PRICINGS_LOG_REPORT_FAILURE,
    payload: {
        error: error,
    },
})
// SUMMARY

export const FETCH_SPECIAL_PRICINGS_SUMMARY_REPORT_REQUESTED = "specialPricingReport/summary/requested"

export const fetchSpecialPricingsSummaryReportRequested = () => ({
    type: FETCH_SPECIAL_PRICINGS_SUMMARY_REPORT_REQUESTED,
})

export const FETCH_SPECIAL_PRICINGS_SUMMARY_REPORT_SUCCESS = "specialPricingReport/summary/success"

export const fetchSpecialPricingsSummaryReportSuccess = (data: SpecialPricingSummaryReportItem[]) => ({
    type: FETCH_SPECIAL_PRICINGS_SUMMARY_REPORT_SUCCESS,
    payload: {
        data: data,
    },
})

export const FETCH_SPECIAL_PRICINGS_SUMMARY_REPORT_FAILURE = "specialPricingReport/summary/failure"

export const fetchSpecialPricingsSummaryReportFailure = (error?: any) => ({
    type: FETCH_SPECIAL_PRICINGS_SUMMARY_REPORT_FAILURE,
    payload: {
        error: error,
    },
})
// EMPLOYEE

export const FETCH_SPECIAL_PRICINGS_EMPLOYEE_REPORT_REQUESTED = "specialPricingReport/employee/requested"

export const fetchSpecialPricingsEmployeeReportRequested = () => ({
    type: FETCH_SPECIAL_PRICINGS_EMPLOYEE_REPORT_REQUESTED,
})

export const FETCH_SPECIAL_PRICINGS_EMPLOYEE_REPORT_SUCCESS = "specialPricingReport/employee/success"

export const fetchSpecialPricingsEmployeeReportSuccess = (data: SpecialPricingSummaryReportItem[]) => ({
    type: FETCH_SPECIAL_PRICINGS_EMPLOYEE_REPORT_SUCCESS,
    payload: {
        data: data,
    },
})

export const FETCH_SPECIAL_PRICINGS_EMPLOYEE_REPORT_FAILURE = "specialPricingReport/employee/failure"

export const fetchSpecialPricingsEmployeeReportFailure = (error?: any) => ({
    type: FETCH_SPECIAL_PRICINGS_EMPLOYEE_REPORT_FAILURE,
    payload: {
        error: error,
    },
})
